import{getCountryFromLocale}from"../../../common/locale";import{findCountryByCode}from"../findCountryByCode";/**
 * Default phone code, the UK one `+44`
 */var DEFAULT_PHONE_CODE="+44";/**
 * Given a valid locale it returns the correspondent prefix if found or +44 otherwise.
 *
 * @param {string} locale - a string that represent the locale ex:'es-ES'
 * @param countryCode
 * @returns {string}
 */export var setDefaultPrefix=function(a,b){var c=findCountryByCode(b)||// when `locale` code has explicit region: `en-GB`, `en-US`, `ar-AE`
findCountryByCode(getCountryFromLocale(a))||// when `locale` code is only two chars value: `fr`, `es`
findCountryByCode(a);return(null===c||void 0===c?void 0:c.phone)||DEFAULT_PHONE_CODE};